import React, { Fragment } from "react";
import AddRefererAuthenticationDialog from "./AddRefererAuthenticationDialog";
import AddEzProxyAuthenticationDialog from "./AddEzProxyAuthenticationDialog";
import AddShibbolethAuthenticationDialog from "./AddShibbolethAuthenticationDialog";
import AddIpAuthenticationDialog from "./AddIpAuthenticationDialog";
import AddBarcodeAuthenticationDialog from "./AddBarcodeAuthenticationDialog";
import AddSipAuthenticationDialog from "./AddSipAuthenticationDialog";
import AddPapiAuthenticationDialog from "./AddPapiAuthenticationDialog";
import AddRegionAuthenticationDialog from "./AddRegionAuthenticationDialog";
import AddScopeAuthenticationDialog from "./AddScopeAuthenticationDialog";

const AuthenticationDialogs = ({
  dialogsState,
  organizationId,
  currentAuthentication,
  onClose,
  onSave,
}) => {
  return (
    <Fragment>
      {dialogsState.referer && (
        <AddRefererAuthenticationDialog
          open={dialogsState.referer}
          organizationId={organizationId}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.ezproxy && (
        <AddEzProxyAuthenticationDialog
          open={dialogsState.ezproxy}
          organizationId={organizationId}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.shibboleth && (
        <AddShibbolethAuthenticationDialog
          open={dialogsState.shibboleth}
          organizationId={organizationId}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.ip && (
        <AddIpAuthenticationDialog
          open={dialogsState.ip}
          organizationId={organizationId}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.barcode && (
        <AddBarcodeAuthenticationDialog
          open={dialogsState.barcode}
          organizationId={organizationId}
          authentication={currentAuthentication}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.sip && (
        <AddSipAuthenticationDialog
          open={dialogsState.sip}
          organizationId={organizationId}
          authentication={currentAuthentication}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.papi && (
        <AddPapiAuthenticationDialog
          open={dialogsState.papi}
          organizationId={organizationId}
          authentication={currentAuthentication}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.region && (
        <AddRegionAuthenticationDialog
          open={dialogsState.region}
          organizationId={organizationId}
          onClose={onClose}
          onSave={onSave}
        />
      )}
      {dialogsState.scope && (
        <AddScopeAuthenticationDialog
          open={dialogsState.scope}
          organizationId={organizationId}
          onClose={onClose}
          onSave={onSave}
        />
      )}
    </Fragment>
  );
};

export default AuthenticationDialogs;
